import moment from 'moment';

/**
 * Takes a moment object and then finds the utc offset and returns the value in minutes
 * @param {timestamp} momentObject
 */
const daylightSavingsCheck = (timeStamp) => {
	if(!timeStamp){
		return null;
	}
	const dateStringArray = timeStamp.toString().split(' ');
	const isDST = moment(timeStamp).isDST();
	const nextDayIsDST = moment(moment(timeStamp).add(1, 'day')).isDST()

	// debug
	// console.log('---- time analysis ---------');
	// console.log(`dateStringArray: ${dateStringArray}`);
	// console.log(`isDST: ${isDST}`);
	// console.log(moment(timeStamp).format())
	// console.log(moment.utc(timeStamp).format())
	// console.log(`nextDayIsDST: ${nextDayIsDST}`);
	// console.log(moment(timeStamp).add(1, 'day').format())
	// console.log(moment.utc(timeStamp).add(1, 'day').format())


	if (isDST != nextDayIsDST) {
		if (isDST == false && nextDayIsDST == true) {
			console.log('springForwardDay')
			return 'springForwardDay'
		}
		if (isDST == true && nextDayIsDST == false) {
			console.log('fallBackwardDay')
			return 'fallBackwardDay'
		}
	} else {
		return isDST;
	}
}

export default daylightSavingsCheck;


// future daylight savings dates

/**
 ********************* New York *********************************
 Year	Date & Time	Abbreviation	Time Change	Offset After
2020
    Sun, Mar 8 at 2:00 am	EST → EDT +1 hour (DST start)	UTC-4h
 		Sun, Nov 1 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2021
    Sun, Mar 14 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 		Sun, Nov 7 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2022
    Sun, Mar 13 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 		Sun, Nov 6 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2023
    Sun, Mar 12 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 5 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2024
	Sun, Mar 10 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 3 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2025
	Sun, Mar 9 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 2 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2026
	Sun, Mar 8 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 1 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2027
	Sun, Mar 14 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 7 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2028
    Sun, Mar 12 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 5 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h
2029
	Sun, Mar 11 at 2:00 am	EST → EDT	+1 hour (DST start)	UTC-4h
 	Sun, Nov 4 at 2:00 am	EDT → EST	-1 hour (DST end)	UTC-5h

*********************** Los Angeles ********************************

Year	Date & Time	 Abbreviation	Time Change	Offset After
2020
	Sun, Mar 8 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 1 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2021
	Sun, Mar 14 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 7 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2022
	Sun, Mar 13 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 6 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2023
	Sun, Mar 12 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 5 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2024
	Sun, Mar 10 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 3 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2025
	Sun, Mar 9 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 2 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2026
	Sun, Mar 8 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 1 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2027
	Sun, Mar 14 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 7 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2028
	Sun, Mar 12 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 5 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
2029
	Sun, Mar 11 at 2:00 am	PST → PDT	+1 hour (DST start)	UTC-7h
 	Sun, Nov 4 at 2:00 am	PDT → PST	-1 hour (DST end)	UTC-8h
 */


 /*


 Notes:

 - When looking forward or looking back, moment recognized EDT and EST accordingly
 -


	*/
